uniform sampler2D uNoise;

varying vec3 vNormal;
varying float vElevation;

void main() {
    // vec3 color = vec3(0.0, .5, 1.0);
    vec3 color = vec3(0.024, 0.329, 0.729);
    color = mix(color, vec3(.95,.95,1.0), smoothstep(0.0, 0.5, vElevation));
    gl_FragColor = vec4(vec3(color), 1.0);
} 